<template>
  <div>
    <!-- Nav tabs-->
    <nav-tabs
      :is-reg-active="isRegisterActive"
      @setIsRegisterActive="isRegisterActive = $event"
    />

    <!-- Tab panes-->
    <tab-panes :is-reg-active="isRegisterActive" />
  </div>
</template>

<script>
import NavTabs from './NavTabs'
import TabPanes from './TabPanes'

export default {
  name: 'NavTabPanes',
  components: { NavTabs, TabPanes },
  data () {
    return {
      isRegisterActive: false
    }
  },
  computed: {},
  methods: {}
}
</script>
